import {IStore} from "../BaseStore";
import {createRef, useEffect} from "react";

export function useSubscribeToStore(store: IStore, onChange: () => void): void {
    const eventListenerRef = createRef();

    useEffect(() => {
        store.onChange(eventListenerRef, onChange);

        return () => {
            store.removeChangeListener(eventListenerRef);
        }
    }, [store, onChange]);
}
